/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Show selected coordinates</h4>

<p>Show or hide coordinates of selected vertices (or all, if none are selected).</p>`;

export function ShowSelectedCoordinatesTooltip() {
    return h('div', { innerHTML: body });
}
